import { ThemeAssets } from 'chessboard/config/theme-assets';
import fallbackPieces from 'chessboard/renderers/default/assets/default-pieces-base64.json';
import fallbackBoard from 'renderers/default/assets/default-board-base64.json';

export const defaultThemeAssets: ThemeAssets.Assets2D = {
  config: {
    perspective: ThemeAssets.Perspective.TOP_DOWN,
  },
  board: {
    assets: {
      background: fallbackBoard.board,
    },
    config: {
      highlightSquareHex: '#ffff00',
      darkSquareCoordinateHex: '#edeed1',
      lightSquareCoordinateHex: '#779952',
    },
  },
  pieces: {
    assets: fallbackPieces,
  },
  sound: {
    assets: {
      capture: {
        webm: 'https://www.chess.com/sounds/_WEBM_/default/capture.webm',
        mp3: 'https://www.chess.com/sounds/_MP3_/default/capture.mp3',
        ogg: 'https://www.chess.com/sounds/_OGG_/default/capture.ogg',
        wav: 'https://www.chess.com/sounds/_WAV_/default/capture.wav',
      },
      castle: {
        webm: 'https://www.chess.com/sounds/_WEBM_/default/castle.webm',
        mp3: 'https://www.chess.com/sounds/_MP3_/default/castle.mp3',
        ogg: 'https://www.chess.com/sounds/_OGG_/default/castle.ogg',
        wav: 'https://www.chess.com/sounds/_WAV_/default/castle.wav',
      },
      gameEnd: {
        webm: 'https://www.chess.com/sounds/_WEBM_/default/game-end.webm',
        mp3: 'https://www.chess.com/sounds/_MP3_/default/game-end.mp3',
        ogg: 'https://www.chess.com/sounds/_OGG_/default/game-end.ogg',
        wav: 'https://www.chess.com/sounds/_WAV_/default/game-end.wav',
      },
      gameStart: {
        webm: 'https://www.chess.com/sounds/_WEBM_/default/game-start.webm',
        mp3: 'https://www.chess.com/sounds/_MP3_/default/game-start.mp3',
        ogg: 'https://www.chess.com/sounds/_OGG_/default/game-start.ogg',
        wav: 'https://www.chess.com/sounds/_WAV_/default/game-start.wav',
      },
      illegal: {
        webm: 'https://www.chess.com/sounds/_WEBM_/default/illegal.webm',
        mp3: 'https://www.chess.com/sounds/_MP3_/default/illegal.mp3',
        ogg: 'https://www.chess.com/sounds/_OGG_/default/illegal.ogg',
        wav: 'https://www.chess.com/sounds/_WAV_/default/illegal.wav',
      },
      moveCheck: {
        webm: 'https://www.chess.com/sounds/_WEBM_/default/move-check.webm',
        mp3: 'https://www.chess.com/sounds/_MP3_/default/move-check.mp3',
        ogg: 'https://www.chess.com/sounds/_OGG_/default/move-check.ogg',
        wav: 'https://www.chess.com/sounds/_WAV_/default/move-check.wav',
      },
      moveOpponent: {
        webm: 'https://www.chess.com/sounds/_WEBM_/default/move-opponent.webm',
        mp3: 'https://www.chess.com/sounds/_MP3_/default/move-opponent.mp3',
        ogg: 'https://www.chess.com/sounds/_OGG_/default/move-opponent.ogg',
        wav: 'https://www.chess.com/sounds/_WAV_/default/move-opponent.wav',
      },
      moveSelf: {
        webm: 'https://www.chess.com/sounds/_WEBM_/default/move-self.webm',
        mp3: 'https://www.chess.com/sounds/_MP3_/default/move-self.mp3',
        ogg: 'https://www.chess.com/sounds/_OGG_/default/move-self.ogg',
        wav: 'https://www.chess.com/sounds/_WAV_/default/move-self.wav',
      },
      notify: {
        webm: 'https://www.chess.com/sounds/_WEBM_/default/notify.webm',
        mp3: 'https://www.chess.com/sounds/_MP3_/default/notify.mp3',
        ogg: 'https://www.chess.com/sounds/_OGG_/default/notify.ogg',
        wav: 'https://www.chess.com/sounds/_WAV_/default/notify.wav',
      },
      premove: {
        webm: 'https://www.chess.com/sounds/_WEBM_/default/premove.webm',
        mp3: 'https://www.chess.com/sounds/_MP3_/default/premove.mp3',
        ogg: 'https://www.chess.com/sounds/_OGG_/default/premove.ogg',
        wav: 'https://www.chess.com/sounds/_WAV_/default/premove.wav',
      },
      promote: {
        webm: 'https://www.chess.com/sounds/_WEBM_/default/promote.webm',
        mp3: 'https://www.chess.com/sounds/_MP3_/default/promote.mp3',
        ogg: 'https://www.chess.com/sounds/_OGG_/default/promote.ogg',
        wav: 'https://www.chess.com/sounds/_WAV_/default/promote.wav',
      },
      tenSeconds: {
        webm: 'https://www.chess.com/sounds/_WEBM_/default/tenseconds.webm',
        mp3: 'https://www.chess.com/sounds/_MP3_/default/tenseconds.mp3',
        ogg: 'https://www.chess.com/sounds/_OGG_/default/tenseconds.ogg',
        wav: 'https://www.chess.com/sounds/_WAV_/default/tenseconds.wav',
      },
    },
  },
};
